import React from 'react';

interface StatCard {
  label: string;
  value: number | string;
  icon: string;
  color: string;
}

interface StatsCardsProps {
  stats: StatCard[];
}

export const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  const colorClasses: { [key: string]: string } = {
    blue: 'bg-gradient-to-br from-blue-500 to-blue-600',
    green: 'bg-gradient-to-br from-green-500 to-green-600',
    purple: 'bg-gradient-to-br from-purple-500 to-purple-600',
    orange: 'bg-gradient-to-br from-orange-500 to-orange-600',
    red: 'bg-gradient-to-br from-red-500 to-red-600',
    amber: 'bg-gradient-to-br from-amber-500 to-amber-600',
    indigo: 'bg-gradient-to-br from-indigo-500 to-indigo-600',
    pink: 'bg-gradient-to-br from-pink-500 to-pink-600',
    teal: 'bg-gradient-to-br from-teal-500 to-teal-600',
    cyan: 'bg-gradient-to-br from-cyan-500 to-cyan-600',
  };

  const textColorClasses: { [key: string]: string } = {
    blue: 'text-blue-100',
    green: 'text-green-100',
    purple: 'text-purple-100',
    orange: 'text-orange-100',
    red: 'text-red-100',
    amber: 'text-amber-100',
    indigo: 'text-indigo-100',
    pink: 'text-pink-100',
    teal: 'text-teal-100',
    cyan: 'text-cyan-100',
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`${colorClasses[stat.color] || colorClasses.blue} rounded-xl p-6 text-white shadow-lg transform hover:scale-105 transition-all duration-300`}
          style={{
            animation: `slideUp 0.5s ease-out`,
            animationDelay: `${index * 100}ms`,
            animationFillMode: 'both',
          }}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className={`${textColorClasses[stat.color] || textColorClasses.blue} text-sm mb-1`}>
                {stat.label}
              </p>
              <p className="text-3xl font-bold">{stat.value}</p>
            </div>
            <span className="text-4xl opacity-80">{stat.icon}</span>
          </div>
        </div>
      ))}
    </div>
  );
};












